import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEaglesoft = lazy(() => import('./svg-components/eaglesoft'));

const Eaglesoft = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEaglesoft {...rest} />
  </Suspense>
);

export default Eaglesoft;
